import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import VaccineBookingModal from "../Modals/VaccineBookingModal";
import "./Vaccine.css";

const Vaccine = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleBookingSubmit = async (bookingDetails) => {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/vaccines/create-booking`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bookingDetails),
      }
    );
    return response;
  };

  const vaccines = [
    "Bacille Calmette-Guerin (BCG) Vaccines",
    "Haemophilus Influenzae type b (Hib) Vaccines",
    "Meningococcal Vaccines",
    "Pneumococcal Vaccines",
    "Typhoid Vaccines",
    "Combined Typhoid and Hepatitis A Vaccines",
    "Hepatitis A Vaccines",
    "Hepatitis B Vaccines",
    "Hepatitis A and B combined Vaccines",
    "Herpes Zoster Vaccines",
    "Human Papillomavirus (HPV) Vaccines",
    "Japanese Encephalitis Vaccines",
    "Rabies Vaccines",
    "Varicella Vaccines",
    "Yellow Fever Vaccines",
  ];

  return (
    <div className="vaccine-page-vaccine">
      {/* HEADER */}
      <header className="header-vaccine">
        <h1 className="title-vaccine">Vaccination Services</h1>
        <p className="subtitle-vaccine">
          Your pharmacist can administer a range of essential vaccines.
        </p>
        <button className="cta-button-vaccine" onClick={handleOpenModal}>
          Request a Vaccination Appointment
        </button>
      </header>

      {/* MAIN CONTENT: Two-Column Layout */}
      <div className="content-section-vaccine">
        {/* Left Column: FAQ & Virtual Travel Clinic */}
        <div className="left-column-vaccine">
          {/* Why Vaccinate FAQ */}
          <section className="faq-section-vaccine">
            <h2>Our Pharmacists Can Vaccinate!</h2>
            <div className="faq-item-vaccine">
              <p>
                Our pharmacists are injection certified and can administer
                several vaccines including flu shot, covid-19 vaccines, Hep A &
                B and a lot more.
              </p>
            </div>
            <div className="faq-item-vaccine">
              <h2>Need the yellow card for travel?</h2>
              <p>
                Our Pharmacy is a{" "}
                <strong>Certified Yellow Fever Vaccination Centre</strong>
              </p>
            </div>
            <div className="faq-item-vaccine">
              <h2>Do I need an appointment?</h2>
              <p>
                Walk‑ins are welcome, but booking ahead ensures minimal wait
                times and personalized care.
              </p>
            </div>
          </section>

          {/* Virtual Travel Clinic Section */}
          <section className="travel-clinic-section-vaccine">
            <h2>Virtual Travel Clinic</h2>
            <p>
              Our partner virtual travel clinic offers personalized travel
              consultations, including advice on required vaccines for your
              destination. They can also prescribe vaccines to ensure you’re
              fully protected on your journey.
            </p>
            <button
              className="travel-cta-button-vaccine"
              onClick={() =>
                window.open("https://www.virtualtravelclinic.ca", "_blank")
              }
            >
              Visit Virtual Travel Clinic
            </button>
            {/* <span onClick={handleOpenModal}>QR Code Here</span> */}
          </section>
        </div>

        {/* Right Column: List of Vaccines */}
        <div className="right-column-vaccine">
          <section className="vaccine-list-section-vaccine">
            <h2>Our Available Vaccines</h2>
            <div className="vaccine-grid-vaccine">
              {vaccines.map((vaccine, index) => (
                <div key={index} className="vaccine-card-vaccine">
                  {vaccine}
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>

      {/* INFO / FOOTER SECTION */}
      <footer className="info-section-vaccine">
        <p>
          Walk‑ins are always welcome, but booking ahead can help reduce wait
          times and ensure you receive personalized care.
        </p>
      </footer>

      <VaccineBookingModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleBookingSubmit}
      />
    </div>
  );
};

export default Vaccine;
